var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuickbooks = function SvgQuickbooks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.3252C22 17.848 17.5228 22.3252 12 22.3252C6.47715 22.3252 2 17.848 2 12.3252C2 6.80235 6.47715 2.3252 12 2.3252C17.5228 2.3252 22 6.80235 22 12.3252Z",
    fill: "#2CA01C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7226 8.41867H15.2666C17.3698 8.41867 19.0748 10.1678 19.0748 12.3254C19.0748 14.483 17.3698 16.2321 15.2666 16.2321H12.5449V5.73975C13.3261 5.73975 13.9594 6.38938 13.9594 7.19083V14.7811H15.2666C16.5865 14.7811 17.6603 13.6795 17.6603 12.3254C17.6603 10.9714 16.5865 9.86975 15.2666 9.86975H14.7226V8.41867ZM8.73584 16.2316C6.63267 16.2316 4.92773 14.4824 4.92773 12.3248C4.92773 10.1672 6.63267 8.41809 8.73584 8.41809H11.4576V18.9105C10.6764 18.9105 10.0431 18.2608 10.0431 17.4594V9.86917H8.73584C7.41597 9.86917 6.34217 10.9707 6.34217 12.3248C6.34217 13.6789 7.41597 14.7805 8.73584 14.7805H9.27985V16.2316H8.73584Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuickbooks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "quickbooks.77001832e2229ca11bead87d5a575e5a.svg";